import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Layout from '../components/Layout';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import Head from '../components/head';
import Section from '../components/Section';
import { FranchiseeProvider } from '../context/Franchisee';
import ServiceTitle from "../components/ServiceTitle";
import ToastWrapper from '../components/ToastWrapper';
import { ListGroup, Toast } from 'react-bootstrap';

interface CustomerSatisfactionPageProps {
  /* add privacy policy page props here */
  customerSatisfaction: any;
}

const CustomerSatisfaction: React.FC<CustomerSatisfactionPageProps> = ({
  customerSatisfaction,
}: CustomerSatisfactionPageProps) => {

    const [showSuccessToast, setShowSuccessToast] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = Object.fromEntries(new FormData(e.target));
        const res = await fetch(`${process.env.GATAWARE_REST_API}/customer-satisfaction/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData)
        });

        if (res.ok) {
            setShowSuccessToast(true)
            e.target.reset();
        } else {
            alert("Error submitting form. Try again.");
        }
    };
  
  return (
    <FranchiseeProvider>
      <Layout alternateFooter>
        <Head
          slug='customer-satisfaction'
          title='Customer Satisfaction - Two Maids Professional Cleaning Services'
          description={`We’re dedicated to safeguarding your personal information & privacy within our professional deep cleaning services.`}
        />
        <OpenGraphTitle title='Customer Satisfaction - Two Maids Professional Cleaning Services' />
        <OpenGraphDescription>
          {/* Add Customer Satisfaction description here */}
          We’re dedicated to safeguarding your personal information & privacy within our professional deep cleaning services.
        </OpenGraphDescription>
        <ServiceTitle imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724956000/hubsite-reskin/New%20Services%20Pages/Recurring-Cleaning.webp">Customer Satisfaction</ServiceTitle>
        <Section>
          <Row className='justify-content-center mt-4'>
            <Col xs={12} lg={10} xl={9}>
              <div className='mb-3'>
                <p>
                    Please share your customer experience with us by completing the Customer Satisfaction Form below.
                </p>
                <p>
                    Please note that customer service questions or concerns are communicated to the franchise location who you contracted services with.
                </p>
                <form onSubmit={handleSubmit}>
                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="first-name">First Name (*)</label>
                        <input name="first-name" type="text" className='form-control' placeholder='First Name' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="last-name">Last Name (*)</label>
                        <input name="last-name" type="text" className='form-control' placeholder='Last Name' required />
                    </div>
                    
                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="suffix">Suffix</label>
                        <input name="suffix" type="text" className='form-control' placeholder='Suffix' />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="mailing-address">Mailing Address (*)</label>
                        <input name="mailing-address" type="text" className='form-control' placeholder='Mailing Address' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="city">City (*)</label>
                        <input name="city" type="text" className='form-control' placeholder='City' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="state">State (*)</label>
                        <input name="state" type="text" className='form-control' placeholder='State' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="zip-code">Zip Code (*)</label>
                        <input name="zip-code" type="text" className='form-control' placeholder='Zip Code' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="mobile-phone">Mobile Phone (*)</label>
                        <input name="mobile-phone" type="text" className='form-control' placeholder='Mobile Phone' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="email-address">Email Address (*)</label>
                        <input name="email-address" type="text" className='form-control' placeholder='Email Address' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="convenient-time">Most Convenient Time/Day to Reach You by Phone (*)</label>
                        <input name="convenient-time" type="text" className='form-control' placeholder='Most Convenient Time/Day to Reach You by Phone' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="date-of-service">Date of Service (*)</label>
                        <input name="date-of-service" type="text" className='form-control' placeholder='Date of Service' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="details-of-experience">Details Regarding Your Experience (*)</label>
                        <textarea name="details-of-experience" className='form-control' placeholder='Details Regarding Your Experience' required />
                    </div>

                    <div className='d-flex flex-column mb-4'>
                        <label htmlFor="overall-experience-rating">Overall Experience Rating (*)</label>

                        <div className="d-flex flex-column gap-3 mt-2">
                            {['Neutral', 'Poor', 'Good', 'Excellent', 'None'].map(rating => (
                            <label key={rating}>
                                <input
                                type="radio"
                                className='mr-2'
                                name="overall-experience-rating"
                                value={rating}
                                required
                                />
                                {rating}
                            </label>
                            ))}
                        </div>
                    </div>

                    <button className='btn btn-primary'>
                        Submit
                    </button>
                </form>
              </div>
            </Col>
          </Row>
        </Section>
      </Layout>
      <ToastWrapper className='confirm-toast-wrapper'>
        <Toast
          show={showSuccessToast}
          onClose={() => setShowSuccessToast(false)}
          autohide
          delay={8000}
        >
          <Toast.Body>
            <ListGroup>
              <ListGroup.Item variant='success'>
                Thank you! Form submitted successfully.
              </ListGroup.Item>
            </ListGroup>
          </Toast.Body>
        </Toast>
      </ToastWrapper>
    </FranchiseeProvider>
  );
};

export default CustomerSatisfaction;
